module.exports = __webpack_public_path__ + "static/media/space-shuttle.63bcaabb.svg";